/**
 * Board do Kanban de Vistorias.
 *
 * @version 1.1.0
 * RELEASE: 2026-09-26 v1.1.0 - Propaga o clique no veículo (modal 360º) até o card.
 * RELEASE: 2026-09-26 v1.0.0 - Paridade arquitetural com Propostas e Contratos.
 */
import { ReadonlyKanbanBoard } from '@/components/kanban/ReadonlyKanbanBoard';
import {
  useInspectionKpis,
  useInspectionsListRealtime,
  type InspectionFilters,
  type InspectionListRow,
} from '@/hooks/useChecklistInstancesList';
import { InspectionKanbanColumn } from './InspectionKanbanColumn';
import { INSPECTION_KANBAN_COLUMNS } from './inspectionKanbanColumns';

interface InspectionKanbanBoardProps {
  filters: InspectionFilters;
  onOpen: (id: string) => void;
  onOpenCustomer: (inspection: InspectionListRow) => void;
  canOpenCustomer: boolean;
  /** Abre o modal 360º do veículo vinculado à vistoria (vínculo congelado). */
  onOpenVehicle: (inspection: InspectionListRow) => void;
  canOpenVehicle: boolean;
}

export function InspectionKanbanBoard({
  filters, onOpen, onOpenCustomer, canOpenCustomer, onOpenVehicle, canOpenVehicle,
}: InspectionKanbanBoardProps) {
  const { data: counts } = useInspectionKpis('kanban', filters);
  useInspectionsListRealtime(true);

  return (
    <ReadonlyKanbanBoard>
      {INSPECTION_KANBAN_COLUMNS.map((column) => (
        <InspectionKanbanColumn
          key={column.status}
          column={column}
          filters={filters}
          total={counts?.[column.status as keyof typeof counts] ?? 0}
          onOpen={onOpen}
          onOpenCustomer={onOpenCustomer}
          canOpenCustomer={canOpenCustomer}
          onOpenVehicle={onOpenVehicle}
          canOpenVehicle={canOpenVehicle}
        />
      ))}
    </ReadonlyKanbanBoard>
  );
}